module.exports = __webpack_public_path__ + "img/pitcairn-islands.3f234160.svg";